import { UserPreferenceActionTypes, UserPreferenceNames, UserPreference } from './types';

const initialState: UserPreference = {
  globalUserPreferences: {
    timeFormat: 'hours24',
    dateFormat: 'ddmmyyyy',
  },
  customUserPreferences: { timeZone: 'UTC'},
  sessionHistory: null,
};

export const userPreferenceReducer = (
  state: UserPreference = initialState,
  action: UserPreferenceActionTypes,
): UserPreference => {
  switch (action.type) {
    case UserPreferenceNames.SET_RECENT_USER_SEARCHES: {
      return {
        ...state,
        customUserPreferences: {
          ...state.customUserPreferences,
          recentlyViewedSearches: action.payload,
        },
      };
    }
    case UserPreferenceNames.SET_SESSION_HISTORY: {
      return {
        ...state,
        sessionHistory: action.payload,
      };
    }
    case UserPreferenceNames.SET_DISPLAY_NAME: {
      return {
        ...state,
        customUserPreferences: {
          ...state.customUserPreferences,
          displayName: action.payload,
        },
      };
    }
    case UserPreferenceNames.SET_TIME_FORMAT: {
      return {
        ...state,
        globalUserPreferences: {
          ...state.globalUserPreferences,
          timeFormat: action.payload,
        },
      };
    }
    case UserPreferenceNames.SET_DATE_FORMAT: {
      return {
        ...state,
        globalUserPreferences: {
          ...state.globalUserPreferences,
          dateFormat: action.payload,
        },
      };
    }
    case UserPreferenceNames.SET_TIME_ZONE: {
      return {
        ...state,
        customUserPreferences: {
          ...state.customUserPreferences,
          timeZone: action.payload,
        },
      };
    }
    default:
      return state;
  }
};
